import { IMerchant, GetMerchantBasicProfileResponse } from "constants/merchants";
import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { MERCHANT_ADMIN_ACCOUNT } from "../constants/action-types";
import { progressActions } from "./base-reducers";

interface IBaseState<T> {
    payload: T;
    error?: { message: string };
}

export interface IMerchantState extends IBaseState<IMerchant> {
    isFetching: false;
    isMutating: false;
    isDeactivating: false;
}

export interface IMerchantBasicProfileState extends IBaseState<GetMerchantBasicProfileResponse> {
    isFetching: false;
    isMutating: false;
}

export interface IMerchantAdminAccountState {
    merchant: IMerchantState;
    merchantBasicProfile: IMerchantBasicProfileState;
}

export const merchantAdminAccount = combineReducers<IMerchantAdminAccountState>({
    merchant: handleActions(
        {
            ...progressActions(MERCHANT_ADMIN_ACCOUNT.MERCHANT.FETCH, "isFetching"),
            ...progressActions(MERCHANT_ADMIN_ACCOUNT.MERCHANT.MUTATE, "isMutating"),
            ...progressActions(MERCHANT_ADMIN_ACCOUNT.MERCHANT.DEACTIVATE, "isDeactivating"),
            ...progressActions(MERCHANT_ADMIN_ACCOUNT.MERCHANT.ACTIVATE, "isActivating"),
        } as any,
        null
    ),
    merchantBasicProfile: handleActions<GetMerchantBasicProfileResponse>(
        {
            ...progressActions(MERCHANT_ADMIN_ACCOUNT.MERCHANT_BASIC_PROFILE.FETCH, "isFetching"),
            ...progressActions(MERCHANT_ADMIN_ACCOUNT.MERCHANT_BASIC_PROFILE.MUTATE, "isMutating"),
        } as any,
        null
    ),
});
